import {fetch} from '@/utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryBizExpeditingList(
  {
    page, size, direction, sort,
  },
) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/biz-expecting-lists`,
    method: 'get',
    params: {
      page,
      size,
      direction,
      sort,
    },
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryBizExpediting(bizExpeditingId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/biz-expeditings/${bizExpeditingId}`,
    method: 'get',
  });
}

/**1234 213
 * 新增
 * @param  orderId
 * @param  status
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _addBizExpediting(
  {
    orderId,
    status,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/biz-expeditings`,
    method: 'post',
    data: {
      orderId,
      status,
    },
  });
}

/**
 * 更新
 * @param bizExpeditingId
 * @param  orderId
 * @param  status
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _updateBizExpediting(bizExpeditingId) {
  return fetch({
    url: `/api/biz-expediting/${bizExpeditingId}`,
    method: 'patch',
  });
}

/**
 * 删除
 * @param bizExpeditingId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _deleteBizExpediting(bizExpeditingId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/biz-expeditings/${bizExpeditingId}`,
    method: 'delete',
  });
}

export default {};
